import React, { useEffect, useState } from "react";
import QuestionCreateBody from "./QuestionCreateBody";
import QuestionCreateHeader from "./QuestionCreateHeader";
import Dropdown from "../../../../parts/dropdown";

const options = [
  {
    text: "Short Answer",
    value: "short",
  },
  {
    text: "Scale",
    value: "scale",
  },
  {
    text: "Check Box",
    value: "checkbox",
  },
  {
    text: "Multiple Choice",
    value: "multiple",
  },
  {
    text: "Bodyweight",
    value: "bodyweight",
  },
  {
    text: "Nutrition Data",
    value: "nutrition",
  },
  {
    text: "Progress Photo",
    value: "progress",
  },
  {
    text: "Daily Steps",
    value: "steps",
  },
  {
    text: "Daily Sleep",
    value: "sleep",
  },
  {
    text: "Daily HRV",
    value: "hrv",
  },
  {
    text: "Body Measurement",
    value: "measurement",
  },
];

const optionsData = {
  short: {
    type: "short",
    body: { description: "Short Answer" },
  },
  bodyweight: {
    title: "Upload your bodyweight",
    type: "bodyweight",
    body: { description: "The user will enter their bodyweight" },
  },
  nutrition: {
    title: "Collect and review nutrition data",
    type: "nutrition",
    body: {
      description:
        "The user will review/edit/add their nutrition data for the report period",
    },
  },
  scale: {
    type: "scale",
    body: { labelLeft: "", labelRight: "" },
  },
  progress: {
    title: "Upload progress photo",
    type: "progress",
  },
  multiple: {
    type: "multiple",
    body: { type: "circle-radio", options: [] },
  },
  checkbox: {
    type: "checkbox",
    body: { type: "box-checkbox", options: [] },
  },
  steps: {
    title: "Collect and review steps data",
    type: "steps",
    body: { description: "The user will enter their steps" },
  },
  sleep: {
    title: "Collect and review sleep data",
    type: "sleep",
    body: { description: "The user will enter their sleep" },
  },
  hrv: {
    title: "Collect and review HRV data",
    type: "hrv",
    body: { description: "The user will enter their HRV" },
  },
  measurement: {
    title: "Enter your body part measurements",
    type: "measurement",
    body: { options: [] },
  },
};

const QuestionCreate = ({
  data,
  setData,
  isEdited = false,
  isOnboarding = false,
}) => {
  const [select, setSelect] = useState(data.type || "short");
  const [dropdownText, setDropdownText] = useState(
    options.find((option) => option.value === data.type)?.text || "Short Answer"
  );
  const [firstEdition, setFirstEdition] = useState(isEdited);

  useEffect(() => {
    if (!firstEdition) {
      setData((previousData) => {
        // Honestly I don't remember for what this is, but I think it's for the questions that don't have editable headers lol
        if (
          [
            "progress",
            "nutrition",
            "bodyweight",
            "sleep",
            "steps",
            "hrv",
            "measurement",
          ].includes(previousData.type) &&
          ![
            "progress",
            "nutrition",
            "bodyweight",
            "sleep",
            "steps",
            "hrv",
            "measurement",
          ].includes(optionsData[select].type)
        ) {
          optionsData[select].title = "";
        }
        return { ...previousData, ...optionsData[select] };
      });
    }
  }, [select, firstEdition]);

  const handleSelectChange = (option) => {
    const { value, text } = option;

    setSelect(value);
    setDropdownText(text);
    setFirstEdition(false);
  };

  const filteredOptions = isOnboarding
    ? options.filter(
        (option) => option.value !== "progress" && option.value !== "bodyweight"
      )
    : options;

  return (
    <div className="questionnaire-question">
      <div className="question-header">
        <QuestionCreateHeader data={data} setData={setData} />
        <Dropdown
          summaryText={dropdownText}
          options={filteredOptions}
          onSelectFn={(receivedOption) => {
            handleSelectChange(receivedOption);
          }}
          fullOption={true}
        />
      </div>
      <div className="question-body">
        <QuestionCreateBody data={data} setData={setData} />
      </div>
    </div>
  );
};

export default QuestionCreate;
